export const GET_FORM_DATA = "/search/all";
export const POST_FORM = "/resume";
export const GET_JOB_POSTINGS = "/jobpost";
export const GET_JOB_DETAILS = "/jobpost";
export const GET_CANDIDATE_BY_EMAIL = "/resume/candidatebyemail";
export const GET_CANDIDATE_BY_PHONE = "/resume/candidatebyphone";
